'use client';

import { ButtonHTMLAttributes, FC } from 'react';
import { UIPriority } from '../enums/ui-priorities';
import clsx from 'clsx';

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    priorityType: UIPriority;
    uiSize?: 'default' | 'compact';
};

const Button: FC<ButtonProps> = ({ children, priorityType, className, uiSize = 'default', ...props }) => {
    return (
        <button
            className={clsx(
                `focus:outline-none appearance-none w-full text-slate-900 placeholder-slate-400 rounded-md ring-1 
                ring-slate-200 shadow-sm justify-center items-center cursor-pointer select-none`,
                uiSize === 'default' && 'text-sm leading-5 py-1.5 min-h-[40px]',
                uiSize === 'compact' && 'text-xs leading-4 py-1 min-h-[32px]',
                className,
                priorityType === UIPriority.PRIMARY && `bg-primary active:inset-shadow-md-primary text-white`,
                priorityType === UIPriority.SECONDARY && `bg-white active:inset-shadow-md-secondary`,
                'disabled:bg-gray-300 active:shadow-none disabled:active:inset-shadow-none disabled:cursor-default',
            )}
            {...props}
        >
            {children}
        </button>
    );
};

export default Button;
